/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type ContractProposalBaseInvestmentToolType =
  (typeof ContractProposalBaseInvestmentToolType)[keyof typeof ContractProposalBaseInvestmentToolType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractProposalBaseInvestmentToolType = {
  investment: "investment",
  commodity: "commodity",
  pension_saving: "pension_saving",
  saving: "saving",
  other: "other",
} as const;
